module.exports = __webpack_public_path__ + "static/img/banner.2429797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/information/banner.png
// module id = xFsU
// module chunks = 0